module.exports = __webpack_public_path__ + "static/media/70 - Logo UI.27bd5bbe.png";